export default __webpack_public_path__ + "dd4031aa4287586d968f4ceebe2a89c2.png";